import { render } from "./RegisterView.vue?vue&type=template&id=3c8e9d8d"
import script from "./RegisterView.vue?vue&type=script&lang=js"
export * from "./RegisterView.vue?vue&type=script&lang=js"

import exportComponent from "Z:\\Adamovyveci\\uhkprojects\\owezaverecny\\secutalk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__